//frontend/src/components/layouts/MetaData.js
import { Helmet } from "react-helmet-async";

export default function MetaData({ title }) {
  return (
    <Helmet>
      <title>{`${title} - MeatBuddy`}</title>
    </Helmet>
  );
}
